import { render, staticRenderFns } from "./UserViewUserInfoCard.vue?vue&type=template&id=5c02cbe2&"
import script from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserInfoCard.vue?vue&type=style&index=0&id=5c02cbe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports